// extracted by css-extract-rspack-plugin
export default {"button":"home-fragment__CurrentLocationButton_button__qipwx","icon":"home-fragment__CurrentLocationButton_icon__fU-c2"};